import React, { useContext, useState } from "react";
import {
  IconSearch,
  IconSettings,
  IconPlus,
  IconChevronLeft,
  IconChevronRight,
  IconCalendar,
  IconAlertTriangle,
} from "@tabler/icons-react"; // Import Tabler Icons
import LayoutDashboard from "layouts/layout-dashboard-collapse"; // Assuming this is a layout component
import { useApp } from "contexts/BookingContext"; // Import AppContext
import SessionBlock from "./components/SessionBlock";
import { useCanvasHandler } from "hooks/useCanvasHandler";
import CreatePage from "./components/create-page";
import DateInputWithIcon from "./components/DateInputWithIcon";
import { AgentProvider, useAgent } from "contexts/v1/masterData/AgentContext";
import { ProductCreateProvider } from "contexts/v1/masterData/ProductCreateContext";
import { ProductProvider } from "contexts/v1/masterData/ProductContext";
import { useCustomer } from "contexts/v1/masterData/CustomerContext";
import { LabelProvider, useLabel } from "contexts/v1/masterData/LabelContext";
import QuickCreatePage from "./components/quick-create";
import Select from "react-select";
import CreatePageBulk from "./components/CreatePageBulk";
import { TripProvider } from "contexts/v1/masterData/TripContext";

const TripReservations = ({ dataPerTrip }) => {
  return (
    <div className="p-4">
      {Object.entries(dataPerTrip).map(([tripId, reservations]) => (
        <div key={tripId} className="mb-4">
          <h3 className="mb-2">Trip ID: {tripId}</h3>
          <ul className="list-unstyled">
            {reservations.map((reservation) => (
              <li key={reservation.id} className="py-2 border-bottom">
                <strong>Guest:</strong> {reservation.guest_name} |{" "}
                <strong>Status:</strong> {reservation.status}
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  );
};

const BookingPageV2 = () => {
  const {
    sessions,
    setIsOpenCanvas,
    bookings,
    dataPerTrip,
    filterOptions,
    updateFilter,
    refetch,
    trips,
  } = useApp();
  const { agents } = useAgent();
  const agentList = agents.data || [];
  // Konversi data agents ke format yang sesuai untuk opsi select
  const agentOption = agentList?.map((agent) => ({
    value: agent.id,
    label: agent.name,
  }));
  const { customers } = useCustomer();
  // uselebel
  const { labels } = useLabel();
  const labelList = labels.data || [];
  const labelOption = labelList?.map((label) => ({
    value: label.id,
    label: label.name,
  }));

  const statusOptions = [
    { value: "booked", label: "Book" },
    { value: "reconfirmed", label: "Re Confirm" },
    { value: "confirmed", label: "Confirmed" },
    { value: "played", label: "Playing" },
    { value: "finished", label: "Finish" },
    { value: "cancelled", label: "Cancelled" },
  ];
  // console.log("BookingPageV2 refetch", refetch);
  // const { agents } = useAgent();
  // console.log("agent", agents);
  // console.log("bookings", bookings);
  // console.log("customers", customers);
  // console.log("booking v2 trips", trips);
  // console.log("booking v2 filterOptions", filterOptions);
  // console.log("date bookpagev2", filterOptions.filters.reservation_date);
  // console.log("booking v2 refetch", refetch());

  console.log("BookingPageV2 sessions", sessions);
  const { handleSuccess, handleError, showCanvasHandler } = useCanvasHandler();
  const handleCreate = (e) => {
    e.preventDefault();
    showCanvasHandler(
      "Create Reservation",
      <ProductProvider>
        <AgentProvider>
          <LabelProvider>
            <TripProvider>
              <CreatePage
                // onSuccess={handleSuccess}
                onSuccess={() => {
                  handleSuccess(true, "Reservation created successfully");
                  refetch();
                  // alert("Reservation created successfully");
                }}
                onError={handleError}
                sessions={sessions}
                customers={customers}
              />
            </TripProvider>
          </LabelProvider>
        </AgentProvider>
      </ProductProvider>
    );
  };

  const handleQuick = (e) => {
    e.preventDefault();
    showCanvasHandler(
      "Quick Reservation",
      <ProductProvider>
        <AgentProvider>
          <LabelProvider>
            <TripProvider>
              <QuickCreatePage
                // onSuccess={handleSuccess}
                onSuccess={() => {
                  handleSuccess(true, "Reservation created successfully");
                  refetch();
                }}
                onError={handleError}
                sessions={sessions}
                customers={customers}
              />
              {/* <CreatePageBulk
                onSuccess={() => {
                  handleSuccess(true, "Reservation created successfully");
                  refetch();
                }}
                onError={handleError}
                sessions={sessions}
                customers={customers}
              /> */}
            </TripProvider>
          </LabelProvider>
        </AgentProvider>
      </ProductProvider>
    );
  };
  return (
    <LayoutDashboard>
      {/* Header */}
      {/* <div className="row gap-2 w-100 p-3 d-flex justify-content-between"> */}
      <div className="row g-3 p-3 justify-content-between">
        {/* Button Create Booking */}
        {/* <div className="col-md-12 d-flex row mt-2"> */}
        {/* <div className="row"> */}
        <div className="col-md-3 col-sm-6 col-xs-6">
          <button className="btn btn-primary w-100" onClick={handleCreate}>
            <IconPlus size={18} className="me-2" />
            <span>Booking</span>
          </button>
        </div>

        {/* Button Quick Booking */}
        <div className="col-md-3 col-sm-6 col-xs-6">
          <button className="btn btn-dark w-100" onClick={handleQuick}>
            <IconPlus size={18} className="me-2" />
            <span>Quick Booking</span>
          </button>
        </div>

        {/* </div> */}
        {/* select agent */}
        <div className="col-md-3 col-sm-6">
          <SelectAgent agentOption={agentOption} />
        </div>
        {/* select label */}
        <div className="col-md-3 col-sm-6">
          {/* <SelectAgent agentOption={agentOption} /> */}
          {/* <select
                className="form-select"
                value={filterOptions.filters.label_id}
                onChange={(e) => updateFilter("label_id", e.target.value)}
              >
                <option value="">All Labels</option>
                {labelOption.map((label) => (
                  <option key={label.value} value={label.value}>
                    {label.label}
                  </option>
                ))}
              </select> */}
          <SelectLabel labelOption={labelOption} />
        </div>
        <div className="col-md-3 col-sm-6">
          <SelectStatus statusOptions={statusOptions} />
        </div>
        {/* </div> */}
        {/* <div className="col-md-4 d-flex row mt-2 justify-content-end"> */}
        {/* <div className="row"> */}
        <div className="col-md-5 col-sm-6">
          <SearchInput />
        </div>
        <div className="col-md-2 col-sm-6">
          {/* <div className="col-md-6 col-sm-6 text-end"> */}
          {/* <DateInputWithIcon /> */}
          <DateInputWithIcon
            value={filterOptions.filters.reservation_date} // Nilai tanggal dari filterOptions
            onChange={(formattedDate) =>
              updateFilter("reservation_date", formattedDate)
            } // Perbarui filter dengan tanggal yang diformat
          />
        </div>
        <div className="col-md-2 col-sm-6">
          {/* <div className="col-md-6 col-sm-6 text-end"> */}
          <div className="btn-group d-flex">
            {/* Tombol Previous (Kemarin) */}
            <button
              className="btn"
              onClick={() => {
                const currentDate = filterOptions.filters.reservation_date
                  ? new Date(filterOptions.filters.reservation_date)
                  : new Date();
                currentDate.setDate(currentDate.getDate() - 1); // Kurangi 1 hari
                const formattedDate = currentDate.toISOString().split("T")[0]; // Format ke yyyy-MM-dd
                updateFilter("reservation_date", formattedDate); // Perbarui filter tanggal
              }}
              title="Previous Day"
            >
              <IconChevronLeft size={18} />
            </button>

            {/* Tombol Next (Besok) */}
            <button
              className="btn"
              onClick={() => {
                const currentDate = filterOptions.filters.reservation_date
                  ? new Date(filterOptions.filters.reservation_date)
                  : new Date();
                currentDate.setDate(currentDate.getDate() + 1); // Tambahkan 1 hari
                const formattedDate = currentDate.toISOString().split("T")[0]; // Format ke yyyy-MM-dd
                updateFilter("reservation_date", formattedDate); // Perbarui filter tanggal
              }}
              title="Next Day"
            >
              <IconChevronRight size={18} />
            </button>
          </div>
        </div>
        {/* </div> */}
        {/* <div className="col-12">
            <SearchInput />
          </div> */}
      </div>
      {/* <div className="rounded-lg">
              Data yg di load pada tanggal:{" "}
              {filterOptions.filters.reservation_date}
            </div> */}
      {/* </div> */}

      {/* Sessions Grid (Placeholder) */}
      <div className="p-4 rounded-lg">
        {/* You can insert session-related content here */}
        {sessions.map((session, index) => (
          <SessionBlock
            key={session.id}
            session={session}
            sessions={sessions}
            // tambahkan bg_trip
            bg_trip={session.bg_trip}
            // datapertrip
            dataPerTrip={dataPerTrip}
            refetch={refetch}
            trips={trips}
            customers={customers}
            filterOptions={filterOptions}
          />
        ))}
      </div>
    </LayoutDashboard>
  );
};

export default BookingPageV2;

// Search Input Component
const SearchInput = () => {
  const { handleSearch, filterOptions } = useApp();
  const [search, setSearch] = useState(filterOptions.search || "");

  return (
    <div className="input-icon">
      <input
        type="text"
        className="form-control"
        placeholder="Search by guest name, code, driver"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        onKeyDown={(e) => handleSearch(e)}
      />

      <span className="input-icon-addon">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="icon icon-tabler icon-tabler-search"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          strokeWidth="2"
          stroke="currentColor"
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
          <circle cx="10" cy="10" r="7" />
          <line x1="21" y1="21" x2="15" y2="15" />
        </svg>
      </span>
    </div>
  );
};

const SelectAgent = ({ agentOption }) => {
  const { filterOptions, updateFilter } = useApp();
  return (
    // <select
    //   className="form-select"
    //   value={filterOptions.filters.agent_id}
    //   onChange={(e) => updateFilter("agent_id", e.target.value)}
    // >
    //   <option value="">All Agents</option>
    //   {agentOption.map((agent) => (
    //     <option key={agent.value} value={agent.value}>
    //       {agent.label}
    //     </option>
    //   ))}
    // </select>
    <Select
      options={agentOption}
      value={agentOption.find(
        (a) => a.value === filterOptions.filters.agent_id
      )}
      // onChange={(selectedOption) => {
      //   updateFilter("agent_id", selectedOption.value);
      // }}
      onChange={(selectedOption) => {
        updateFilter("agent_id", selectedOption ? selectedOption.value : ""); // ✅ Jika null, set kosong
      }}
      isClearable
      placeholder="Agent"
      menuPortalTarget={document.body} // Render dropdown ke body
      styles={{
        menuPortal: (base) => ({ ...base, zIndex: 1050 }), // Pastikan z-index tinggi
      }}
    />
  );
};

const SelectLabel = ({ labelOption }) => {
  const { filterOptions, updateFilter } = useApp();
  return (
    // <select
    //   className="form-select"
    //   value={filterOptions.filters.label_id}
    //   onChange={(e) => updateFilter("label_id", e.target.value)}
    // >
    //   <option value="">All Labels</option>
    //   {labelOption.map((label) => (
    //     <option key={label.value} value={label.value}>
    //       {label.label}
    //     </option>
    //   ))}
    // </select>
    <Select
      options={labelOption}
      value={labelOption.find(
        (a) => a.value === filterOptions.filters.label_id
      )}
      onChange={(selectedOption) => {
        updateFilter("label_id", selectedOption ? selectedOption.value : ""); // ✅ Jika null, set kosong
      }}
      isClearable
      placeholder="Label"
      menuPortalTarget={document.body} // Render dropdown ke body
      styles={{
        menuPortal: (base) => ({ ...base, zIndex: 1050 }), // Pastikan z-index tinggi
      }}
    />
  );
};

const SelectStatus = ({ statusOptions }) => {
  const { filterOptions, updateFilter } = useApp();
  return (
    // <select
    //   className="form-select"
    //   value={filterOptions.filters.status}
    //   onChange={(e) => updateFilter("status", e.target.value)}
    // >
    //   <option value="">All Status</option>
    //   {statusOptions.map((status) => (
    //     <option key={status.value} value={status.value}>
    //       {status.label}
    //     </option>
    //   ))}
    // </select>
    <Select
      options={statusOptions}
      value={statusOptions.find(
        (a) => a.value === filterOptions.filters.status
      )}
      onChange={(selectedOption) => {
        updateFilter("status", selectedOption ? selectedOption.value : ""); // ✅ Jika null, set kosong
      }}
      isClearable
      placeholder="Status"
      menuPortalTarget={document.body} // Render dropdown ke body
      styles={{
        menuPortal: (base) => ({ ...base, zIndex: 1050 }), // Pastikan z-index tinggi
      }}
    />
  );
};
